<div [ngSwitch]="brandCode">
  <app-mq-sir-footer *ngSwitchCase="TenantCode.SIR"></app-mq-sir-footer>
  <app-mq-cbr-footer *ngSwitchCase="TenantCode.CBR"></app-mq-cbr-footer>
</div>
